"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectFromEntries = void 0;
/**
 * Object.fromEntries is not supported on all browsers, so implement it ourselves.
 *
 * See https://github.com/feross/fromentries for more info.
 */
function objectFromEntries(entries) {
    return __spreadArray([], __read(entries), false).reduce(function (obj, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        obj[key] = val;
        return obj;
    }, {});
}
exports.objectFromEntries = objectFromEntries;
